import {
    ThemeSet,
} from "cartovista";
export default class FlowThemeSet extends ThemeSet{
    constructor(id) {
        super(id);
        this.styleTheme = null;

        this._map = window.cartovista.externalInterface.map;
        this._flowController = window.cartovista.getFlowController();
        this._jsonFlowConnector = this._flowController._flowConnector;
        this._map.addEventListener(this._map.EVENTS.ACTIVE_THEME_SET_CHANGED, this._onActiveThemeSetChanged, this);
        this.addOneTimeEventListener(this.EVENTS.DESTROYED, this._onThemeSetDestroyed, this);
    }

    _onThemeSetDestroyed(){
        this._map.removeEventListener(this._map.EVENTS.ACTIVE_THEME_SET_CHANGED, this._onActiveThemeSetChanged, this);
    }

    _onActiveThemeSetChanged(){
        if(this._map.activeThemeSet && this.id == this._map.activeThemeSet.id){
            this._flowController.referenceLayer = this._referenceLayer;
            this._jsonFlowConnector.referenceLayer = this._referenceLayer;
            this._jsonFlowConnector.flowDataFilePath = this._flowDataFilePath;
            this._jsonFlowConnector.arrayField = this._arrayField;
            this._jsonFlowConnector.originFeatureIdField = this._originFeatureIdField;
            this._jsonFlowConnector.originFeatureNameField = this._originFeatureNameField;
            this._jsonFlowConnector.destinationFeatureIdField = this._destinationFeatureIdField;
            this._jsonFlowConnector.destinationFeatureNameField = this._destinationFeatureNameField;
            this._jsonFlowConnector.featureValueField = this._featureValueField;
            this._jsonFlowConnector._defaultThemeSet = this;
            this._jsonFlowConnector.styleTheme = this.styleTheme;
            this._flowController.refreshData();
			this.addDefaultFlow();
        }
    }

    addDefaultFlow() {
		//Add the default flow to current theme set
		if (typeof this._defaultFlowFeatureId !== 'undefined' && this._defaultFlowFeatureId !== null && this._defaultFlowFeatureId !== "") {
			this._referenceLayer.getFeatures([this._defaultFlowFeatureId], function(result) {
				this._referenceLayer.dispatchFlowSelectionChangedEvent(result.features[0], "origin", false);
			}.bind(this), true);
		}
	};

    clone(){
        var e = new FlowThemeSet(this.id);
          e.title = this._title,
          e.themeSetMode = this._themeSetMode,
          e._themeSetMapSettings = this._themeSetMapSettings.clone();
          var t = [];
          if (this._themes)
              for (var i = this._themes.length, n = 0; n < i; n++)
                  t.push(this._themes[n].clone());
          return e.addTheme(t),
          e
    }

    toString() {
      return "FlowThemeSet";
    };

}